<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	  data?: { date: string; successful: number; failed: number }[]
}>()

const chartOptions = computed(() => ({
	  tooltip: {
		      trigger: 'axis',
		      axisPointer: {
			            type: 'cross',
			            label: {
					            backgroundColor: '#6a7985'
					          }
			          }
		    },
	  legend: {
		      data: ['Successful', 'Failed']
		    },
	  grid: {
		      left: '3%',
		      right: '4%',
		      bottom: '3%',
		      containLabel: true
		    },
	  xAxis: [
		      {
			            type: 'category',
			            boundaryGap: false,
			            data: props.data?.map(item => item.date) || []
			          }
		    ],
	  yAxis: [
		      {
			            type: 'value',
			            name: 'Transfers'
			          }
		    ],
	  series: [
		      {
			            name: 'Successful',
			            type: 'line',
			            stack: 'Total',
			            areaStyle: {},
			            emphasis: {
					            focus: 'series'
					          },
			            data: props.data?.map(item => item.successful) || [],
			            color: '#22c55e'
			          },
		      {
			            name: 'Failed',
			            type: 'line',
			            stack: 'Total',
			            areaStyle: {},
			            emphasis: {
					            focus: 'series'
					          },
			            data: props.data?.map(item => item.failed) || [],
			            color: '#ef4444'
			          }
		    ]
}))
</script>

<template>
	  <BaseChart :options="chartOptions" class="h-full w-full" />
</template>
